import initialState from './initialState';
import actionTypes from './actions/action-types';

export default (state = initialState, action) => {
  delete state.error;
  if (action.error) {
    return { ...state, error: action.error };
  }

  switch (action.type) {
    case actionTypes.SET_REDIRECT_URL:
      state = { ...state, redirectUrl: action.url };
      break;
    case actionTypes.RECEIVE_USER:
      const { user, isPasswordSet, shouldPasswordBeSet } = action;
      const isLoggedIn = user !== null;
      const isFullyLoggedIn = isLoggedIn && (isPasswordSet || !shouldPasswordBeSet);
      state = { ...state, isLoggedIn, user, isPasswordSet, shouldPasswordBeSet, isFullyLoggedIn };
      break;
    case actionTypes.SET_USER_PASSWORD:
      state = { ...state, isPasswordSet: true, isFullyLoggedIn: true };
    case actionTypes.RECEIVE_EXPENSES:
      const { expenses, month, year } = action;
      state = {
        ...state,
        expenses: { ...state.expenses, ...expenses },
        months: { [month]: month, ...state.months },
        years: { [year]: year, ...state.years }
      };
      break;
    case actionTypes.RECEIVE_ACCOUNTS:
      const { accounts } = action;
      state = { ...state, accounts: { ...state.accounts, ...accounts } };
      break;
    case actionTypes.DELETED_EXPENSE:
      delete state.expenses[action._id];
      state = { ...state, expenses: { ...state.expenses } };
      break;
    case actionTypes.DELETED_ACCOUNT:
      delete state.accounts[action._id];
      state = { ...state, accounts: { ...state.accounts } };
      break;
    case actionTypes.REMOVE_MONTHS:
      state = { ...state, months: {}, years: {} };
      break;
    default:
      break;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducer.ts